import { createContext } from 'react';

const InitialState = {
  baseUserList: [],
  userList: [],
  selectedUserList: [],
  isLoading: true,
  sending: false,
  teamInfo: { teamName: '', initialProfileIds: [] },
  userProductFeaturesMap: {},
  noLicenseModal: false,
  multiLicenseModal: '',
  assignLicenseModal: '',
  assignLicenseBody: [],
};

const actionTypes = {
  SET_BASE_USER_LIST: 'SET_BASE_USER_LIST',
  SET_USER_LISTS: 'SET_USER_LISTS',
  SET_USER_CHECKED_STATUS: 'SET_USER_CHECKED_STATUS',
  SET_USER_CHECKED_STATE: 'SET_USER_CHECKED_STATE',
  FILTER_USER_LIST_BY_SEARCH: 'FILTER_USER_LIST_BY_SEARCH',
  SET_IS_LOADING: 'SET_IS_LOADING',
  SET_EDIT_TEAM_CHECKED_USERS: 'SET_EDIT_TEAM_CHECKED_USERS',
  SET_SENDING: 'SET_SENDING',
  SET_TEAM_INFO: 'SET_TEAM_INFO',
  SET_USERS_FEATURES: 'SET_USERS_FEATURES',
  SET_NO_LICENSE_MODAL: 'SET_NO_LICENSE_MODAL',
  SET_ASSIGN_LICENSE_MODAL: 'SET_ASSIGN_LICENSE_MODAL',
  SET_MULTI_NO_LICENSE_MODAL: 'SET_MULTI_NO_LICENSE_MODAL',
  SET_ASSIGN_LICENSE_BODY: 'SET_ASSIGN_LICENSE_BODY',
};

const CreateTeamContext = createContext(InitialState);

export { CreateTeamContext, InitialState, actionTypes };
